import { useState } from "react";
import { Menu, X, Phone, ArrowRight } from "lucide-react";
import { PHONE_DISPLAY, PHONE_TEL } from "../lib/data";

const LINKS = [
  { label: "Accueil", href: "#accueil", id: "accueil" },
  { label: "Services", href: "#services", id: "services" },
  { label: "Tarifs", href: "#tarifs", id: "tarifs" },
  { label: "À propos", href: "#apropos", id: "apropos" },
  { label: "Avis", href: "#avis", id: "avis" },
  { label: "Contact", href: "#contact", id: "contact" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="main-header"
      className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-white/80 border-b border-sky-100"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-12 h-[72px] flex items-center justify-between gap-4">
        <a href="#accueil" data-testid="header-logo" className="flex items-center shrink-0">
          <img src="/logo.png" alt="WM Clean — Nettoyage de vitres à Lille" className="h-11 w-auto" />
        </a>

        <nav data-testid="header-nav" className="hidden lg:flex items-center gap-7">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`nav-link-${l.id}`}
              className="text-sm font-medium text-slate-600 hover:text-sky-600 transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href={PHONE_TEL}
            data-testid="main-header-phone-button"
            className="hidden md:flex items-center gap-2 text-sm font-semibold text-slate-700 hover:text-sky-600 transition-colors"
          >
            <Phone size={16} className="text-sky-600" />
            {PHONE_DISPLAY}
          </a>
          <a
            href="#devis"
            data-testid="header-cta-devis"
            className="hidden sm:inline-flex items-center gap-2 rounded-full bg-sky-600 hover:bg-sky-700 text-white text-sm font-semibold px-5 py-2.5 shadow-lg shadow-sky-600/25 transition-colors"
          >
            Devis gratuit <ArrowRight size={15} />
          </a>
          <button
            data-testid="mobile-menu-toggle"
            onClick={() => setOpen(!open)}
            className="lg:hidden w-10 h-10 flex items-center justify-center rounded-xl border border-slate-200 text-slate-700"
            aria-label="Menu"
          >
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="mobile-menu" className="lg:hidden bg-white border-t border-sky-100 px-6 py-5 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a
              key={l.id}
              href={l.href}
              data-testid={`mobile-nav-link-${l.id}`}
              onClick={() => setOpen(false)}
              className="text-base font-medium text-slate-700"
            >
              {l.label}
            </a>
          ))}
          <a
            href={PHONE_TEL}
            data-testid="mobile-menu-phone-button"
            className="flex items-center gap-2 text-sky-600 font-semibold"
          >
            <Phone size={16} /> {PHONE_DISPLAY}
          </a>
          <a
            href="#devis"
            data-testid="mobile-menu-cta-devis"
            onClick={() => setOpen(false)}
            className="inline-flex items-center justify-center gap-2 rounded-full bg-sky-600 text-white font-semibold px-5 py-3"
          >
            Devis gratuit <ArrowRight size={15} />
          </a>
        </div>
      )}
    </header>
  );
};
